<template>
  <mu-container>
    <mu-paper :z-depth="1" class="w-100 p-20">
      <mu-row>
        <mu-col span="9">
          <h1>Twoje zamówienia</h1>
        </mu-col>
        <mu-col span="3" style="padding-top: 10px;">
          <strong>Wybierz zakres dat</strong>:
          <date-range-picker
            ref="picker"
            :locale-data="locale"
            :minDate="minDate"
            :maxDate="maxDate"
            :date-range="dateRange"
            @update="updateRange"
          >
            <div slot="input" style="min-width: 250px;">
              {{ startDate }} - {{ endDate }}
            </div>
          </date-range-picker>
          <!-- <date-range-picker
                  ref="picker"
                  :date-range="dateRange"
                  @update="updateRange"
                  :locale-data="locale"
                  :ranges="ranges"
                  style="cursor: pointer;"
          >
            <div slot="input" slot-scope="picker" style="min-width: 350px;">
              {{ startDate | date }} - {{ endDate | date }}
            </div>
          </date-range-picker> -->
        </mu-col>
      </mu-row>
      <mu-expansion-panel v-for="rowOrder in orders" :key="rowOrder.id">
        <div slot="header">
          {{ rowOrder.id }} - {{ rowOrder.dateAdded }} -
          <span :style="{ color: getStateColor(rowOrder.currentState) }">
            {{ formatState(rowOrder.currentState) }}
          </span>
        </div>
        <p>Imię i Nazwisko: {{ rowOrder.name }}</p>
        <p>Wartość zamówienia: {{ rowOrder.totalAll }} zł</p>
        <p>Twój zysk: {{ rowOrder.earnings }} zł</p>
      </mu-expansion-panel>
    </mu-paper>
  </mu-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import DateRangePicker from "vue2-daterange-picker";
import "@/assets/css/vue-daterange-picker.min.css";

export default {
  components: { DateRangePicker },
  name: "HistoryPage",
  data() {
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 6);
    const endDate = new Date();

    return {
      minDate: "2018-12-01",
      maxDate: endDate.toLocaleDateString("en-US").replace(/[.]/g, "-"),
      startDate: startDate.toLocaleDateString("en-US").replace(/[.]/g, "-"),
      startDateTimestamp: +startDate,
      endDate: endDate.toLocaleDateString("en-US").replace(/[.]/g, "-"),
      endDateTimestamp: +endDate,
      dateRange: {
        startDate: this.startDate,
        endDate: this.endDate
      },
      locale: {
        direction: "ltr",
        format: "DD-MM-YYYY",
        separator: " - ",
        applyLabel: "Wybierz",
        cancelLabel: "Anuluj",
        weekLabel: "tyg",
        customRangeLabel: "Wybierz zakres dat zamówień",
        daysOfWeek: ["Nie", "Pon", "Wt", "Śr", "Czw", "Pi", "Sob"],
        monthNames: [
          "Styczeń",
          "Luty",
          "Marzec",
          "Kwiecień",
          "Maj",
          "Czerwiec",
          "Lipiec",
          "Sierpień",
          "Wrzesień",
          "Październik",
          "Listopad",
          "Grudzień"
        ],
        firstDay: 1
      },
      ranges: {}
    };
  },
  computed: {
    ...mapState("order", ["orders"])
  },
  methods: {
    ...mapActions("order", ["getOrders"]),
    formatState(state) {
      switch (state) {
        case 4:
          return "Zrealizowane";
        case 12:
          return "Oczekujące";
        case 7:
          return "Zwrot klienta";
        default:
          return "Nieznany";
      }
    },
    getStateColor(state) {
      switch (state) {
        case 4:
          return "#00ff00";
        case 12:
          return "#ffcc00";
        case 7:
          return "#ff0000";
        default:
          return "#000000";
      }
    },
    updateRange(newRange) {
      this.startDateTimestamp = +newRange.startDate.setMonth(
        newRange.startDate.getMonth() + 1
      );
      this.endDateTimestamp = +newRange.endDate.setMonth(
        newRange.endDate.getMonth() + 1
      );
      this.startDate = newRange.startDate
        .toLocaleDateString("en-US")
        .replace(/[.]/g, "-");
      this.endDate = newRange.endDate
        .toLocaleDateString("en-US")
        .replace(/[.]/g, "-");
      this.getOrders({
        from: this.startDateTimestamp,
        to: this.endDateTimestamp
      });
    }
  },
  created() {
    this.getOrders({
      from: this.startDateTimestamp,
      to: this.endDateTimestamp
    });
  }
};
</script>

<style scoped>
h1 {
  margin: 0;
}
</style>
